import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { VisuallyLogo } from '@/features/strapi/components/logo';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { SocialLinks } from '@/features/new-landing-page/components/social-links';
import { breakpoints } from '@/components/responsive';

export function Footer() {
  return (
    <Wrapper>
      <Left>
        <VisuallyLogo invert wide />
        <StrapiTextual
          text={`The Shopify CRO Platform,\nfueled by data and AI`}
        />
        <RatingWrapper>
          <StarsRatingIcon />
          <span>(5.0)</span>
        </RatingWrapper>
        <SocialLinks />
      </Left>
      <Right>
        <LinksList>
          <StrapiTextual
            href="/public/talk-to-expert"
            text="Talk to an expert"
          />
          <StrapiTextual href="/public/customers" text="Customers" />
          <StrapiTextual href="/public/partners" text="Partners" />
          <StrapiTextual href="/product-demo" text="Product Demo" />
          <StrapiTextual href="/pricing" text="Pricing" />
          <StrapiTextual
            href="/public/inspirations/listing"
            text="Inspirations"
          />
          <StrapiTextual
            href="https://help.visually.io"
            text="Help Center"
            openInNewTab
          />
          <StrapiTextual
            href="https://status.visually.io"
            text="Service Status"
          />
          <StrapiTextual href="/public/privacy-policy" text="Privacy Policy" />
        </LinksList>
        <LinksList>
          <StrapiTextual
            href="/public/comparison/dy/"
            text="Visually vs Dynamic Yield"
          />
          <StrapiTextual
            href="/public/comparison/rebuy/"
            text="Visually vs Rebuy"
          />
          <StrapiTextual
            href="/public/comparison/intelligems/"
            text="Visually vs Intelligems"
          />
          <StrapiTextual
            href="/public/comparison/shoplift/"
            text="Visually vs Shoplift"
          />
        </LinksList>
      </Right>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #1e1f20;
  width: 100%;
  padding: 8rem 14rem;
  color: white;
  grid-gap: 2rem;

  ${breakpoints.down(`md`)} {
    grid-template-columns: 1fr;
    padding: 8rem;
    justify-items: center;
    align-items: center;
  }

  * {
    letter-spacing: -1px;
    font-size: 1.7rem;
    font-weight: normal;
    text-align: left;
    line-height: 1.3;

    ${breakpoints.down(`md`)} {
      text-align: center;
    }
  }
`;

const Left = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 3rem;

  ${breakpoints.down(`md`)} {
    text-align: center;
    justify-items: center;
    align-items: center;
  }
`;

const Right = styled.div`
  margin-top: 3rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: flex-start;

  && > *:nth-child(1) {
    order: 2;
  }

  && > *:nth-child(2) {
    order: 1;
  }

  ${breakpoints.down(`md`)} {
    grid-template-columns: 1fr;
    gap: 4rem;

    && > *:nth-child(1) {
      order: 1;
    }

    && > *:nth-child(2) {
      order: 2;
    }
  }
`;

const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2rem;

  ${breakpoints.down(`md`)} {
    text-align: center;
    justify-items: center;
    align-items: center;
  }
`;

const RatingWrapper = styled.span`
  color: #ffffff;
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 1rem;
  justify-content: flex-start;
  align-items: center;
  * {
    font-size: 1.4rem;
  }

  .gatsby-image-wrapper {
    height: 1.7rem;
  }
`;

function StarsRatingIcon() {
  return (
    <>
      <StaticImage
        className="only-desktop"
        src="../../../assets/landing/stars-rating-row-white.png"
        alt="Shopify Logo"
        placeholder="none"
        loading="eager"
        quality={100}
        width={100}
        objectFit="contain"
      />
      <StaticImage
        className="only-mobile"
        src="../../../assets/landing/stars-rating-row-white.png"
        alt="Shopify Logo"
        placeholder="none"
        loading="eager"
        width={100}
        objectFit="contain"
      />
    </>
  );
}
